<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
        <wcinput :option="{placeholder:'认证费用名称',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'添加费用设置'}" @finish="$parent.JUMPVIEW({name:'AddEsAutoPrice'})"/>
        </el-form-item>
    </el-form>
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="name" label="认证费用名称" align="center" />
        <el-table-column prop="price" label="认证费用" align="center" />
        <el-table-column prop="timename" label="认证周期" align="center"/>
        <el-table-column prop="orders" label="累计认证次数" align="center"/>
        <el-table-column prop="orderprice" label="累计认证金额" align="center"/>
        <el-table-column prop="inputtime" label="添加时间" align="center"/>
        <el-table-column label="上下架" align="center">
            <template #default="scope">
                <el-switch v-model="scope.row.isshow" @change="ChangeShow(scope.row)" />
            </template>
        </el-table-column>
        <el-table-column label="排序" align="center">
            <template #default="scope">
                <div class="TTL-info">
                <wcinput :option="{placeholder:'排序',type:'input',ischange:true,width:'100px'}" 
                    :value="scope.row.sort"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            scope.row.sort=val.value;
                            ChangeSort(scope.row.id,scope.row.sort);
                        }
                    }"
                />
                </div>
            </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center" min-width="150">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'编辑'}" @finish="$parent.JUMPVIEW({name:'EsEditAutoPrice',param:{id:scope.row.id}})" class="left10"/>
                <wcbutton :option="{title:'删除',type:'del'}" @finish="delAuto(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>



</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'memberauto',
            param: {
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.GET_AUTH_SETTING_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
                 for(var i in this.list) this.list[i].isshow=this.list[i].isshow==1 ? true : false;
            });
        },


        /** 修改排序 **/
        ChangeSort(id,sort) {
            INTERFACE_MODEL_MEMBER.CHANGE_AUTO_PRICE_SORT({id:id,sort:sort}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


        /** 修改上下架 **/
        ChangeShow(item) {
            var id=item.id;
            var isshow=item.isshow;
            isshow ? isshow=1 : isshow=0;
            INTERFACE_MODEL_MEMBER.CHANGE_AUTO_PRICE_SHOW({id:id,isshow:isshow}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetList();
            });
        },

        
        /** 删除设置 **/
        delAuto(id) {
            INTERFACE_MODEL_MEMBER.DEL_AUTO_PRICE({ids:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.TTL-info {display: inline-flex;justify-content: center;}
::v-deep(.TTL-info .TTL-input .el-input__inner) {text-align: center;}
.TTL-renewname {color:#666eeb;cursor: pointer;}
</style>